var map = {
	"./home-icon01.png": "a79b",
	"./home-icon02.png": "e62c",
	"./home-icon03.png": "8d95",
	"./home-icon04.png": "3db9",
	"./home-icon05.png": "6a1b",
	"./home-icon06.png": "bf88"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7a1c";